import Raven from 'raven-js';
import identity from 'transmute/identity';
import { InMemoryCache } from '../InMemoryCache';
const fetchValidateEmail = (email, httpClient) => {
  return httpClient.post('property-validation/v1/property-validation/evaluate-proposed-rules', {
    data: {
      proposedRules: [{
        ruleType: 'EMAIL',
        ruleArguments: []
      }],
      proposedValue: email
    }
  }).then(result => {
    if (result.length > 0) {
      return result[0];
    }
    return {
      isValid: true,
      error: null,
      message: null
    };
  }).catch(error => {
    Raven.captureException(error, {
      extra: {
        email
      }
    });
  });
};
export const makeEmailValidationCache = () => new InMemoryCache('EmailValidationCache', fetchValidateEmail, identity);